import { BaseColumnSchemaPart, PosixDateTransformer, } from "@for-it/domain-lib";
import { EntitySchema } from "typeorm";
export const UserEntity = new EntitySchema({
    name: "simpleUser",
    columns: {
        ...BaseColumnSchemaPart,
        firstName: { type: "varchar" },
        lastName: { type: "varchar" },
        email: { type: "varchar", unique: true },
        hashedPassword: { type: "varchar" },
        enabled: { type: "boolean" },
        emailValidationToken: { type: "varchar", nullable: true },
        passwordResetToken: { type: "varchar", nullable: true },
        passwordResetTokenUpdatedAt: {
            type: "bigint",
            nullable: true,
            transformer: PosixDateTransformer,
        },
        passwordResetAttemptsCount: { type: "int", default: 0 },
        avatar: { type: "varchar", nullable: true },
        bio: { type: "text", nullable: true },
        dateOfBirth: {
            type: "bigint",
            nullable: true,
            transformer: PosixDateTransformer,
        },
        phoneNumber: { type: "varchar", nullable: true },
    },
});
export function filterSecureUserProperties(user) {
    return {
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        enabled: user.enabled,
        createdAt: user.createdAt,
        updatedAt: user.updatedAt,
        phoneNumber: user.phoneNumber ? user.phoneNumber : undefined,
        avatar: user.avatar ? user.avatar : undefined,
        bio: user.bio ? user.bio : undefined,
        dateOfBirth: user.dateOfBirth ? user.dateOfBirth : undefined,
        deletedAt: user.deletedAt ? user.deletedAt : undefined,
    };
}
